import React from 'react';

const ProductChainIcon = ({ product }) => {
  return (
    <a href={product.Url} title={product.Name}>
      <svg className="link-icon">
        <use href="/ui/images/sprites/brenderup.svg#link"></use>
      </svg>
    </a>
  );
};

export default ProductChainIcon;
